var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],ref:"swipeAnimationContainer",class:[{ 'swipe-animation-container': true, 'swipe-animation': _vm.display }, _vm.className]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }